module.exports = __webpack_public_path__ + "static/img/00016B_8_9_10_R_20200612_LC.127b369.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/00016B_8_9_10_R_20200612_LC.png
// module id = X8hy
// module chunks = 0